/**
 * Bikefanatics: bike configurator hub (sections/bf-configurator-hub.liquid).
 *
 * - Loads configurable models for every BCF brand in data-brands (ridley,
 *   merckx, nukeproof) from the public BCF API (CORS "*", no key).
 * - Renders brand tabs, range tabs and model cards; each card links to
 *   ?model=CODE&brand=…&name=…#konfiguraator on the same page.
 * - Hero: a 3D carousel of paint-colour cards rotates; the bike image
 *   (model PNG with transparent background) is recoloured on a canvas to
 *   the colour of the card in front. Pixels close in hue to the model's
 *   `extractedFrameColorFromImage` are shifted to the target hue/saturation
 *   while keeping their lightness, so shading survives.
 */
(function () {
  'use strict';

  var API = 'https://api.cyclingfactory.be/v1/b2c/customizer/models?brand=';
  var manifestPromise = null;

  function loadLayerManifest(url) {
    if (!url) return Promise.resolve(null);
    if (!manifestPromise) {
      manifestPromise = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return manifestPromise;
  }
  window.bfLoadLayerManifest = loadLayerManifest;
  var RANGE_ORDER = ['Road', 'All-Road', 'Gravel', 'Corsa', 'Cyclo-cross', 'Time Trial, Triathlon & Track',
    'Trail/All-Mountain', 'Enduro', 'Super Enduro', 'Downhill', 'Pumptrack / Dirt Jump'];
  var RANGE_LABELS = {
    et: { 'Road': 'Maantee', 'All-Road': 'All-road', 'Gravel': 'Gravel', 'Corsa': 'Corsa (teras & titaan)', 'Cyclo-cross': 'Cyclocross',
      'Time Trial, Triathlon & Track': 'Eraldistart & triatlon', 'Trail/All-Mountain': 'Trail / all-mountain', 'Enduro': 'Enduro',
      'Super Enduro': 'Super enduro', 'Downhill': 'Downhill', 'Pumptrack / Dirt Jump': 'Pumptrack / dirt', all: 'Kõik' },
    fi: { 'Road': 'Maantie', 'All-Road': 'All-road', 'Gravel': 'Gravel', 'Corsa': 'Corsa (teräs & titaani)', 'Cyclo-cross': 'Cyclocross',
      'Time Trial, Triathlon & Track': 'Aika-ajo & triathlon', 'Trail/All-Mountain': 'Trail / all-mountain', 'Enduro': 'Enduro',
      'Super Enduro': 'Super enduro', 'Downhill': 'Downhill', 'Pumptrack / Dirt Jump': 'Pumptrack / dirt', all: 'Kaikki' },
    en: { 'Road': 'Road', 'All-Road': 'All-road', 'Gravel': 'Gravel', 'Corsa': 'Corsa (steel & titanium)', 'Cyclo-cross': 'Cyclo-cross',
      'Time Trial, Triathlon & Track': 'Time trial & triathlon', 'Trail/All-Mountain': 'Trail / all-mountain', 'Enduro': 'Enduro',
      'Super Enduro': 'Super enduro', 'Downhill': 'Downhill', 'Pumptrack / Dirt Jump': 'Pumptrack / dirt jump', all: 'All' }
  };

  function money(amount, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return amount + ' ' + (currency || 'EUR');
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  var hexToRgb = function (h) { return window.BfHeroStage.hexToRgb(h); };
  var rgbToHsl = function (r, g, b) { return window.BfHeroStage.rgbToHsl(r, g, b); };

  /* ---------- hub element ---------- */
  class BfConfiguratorHub extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-bf-hub-grid]');
      this.tabs = this.querySelector('[data-bf-hub-tabs]');
      this.brandTabs = this.querySelector('[data-bf-hub-brand-tabs]');
      this.heroBrands = this.querySelector('[data-bf-hub-hero-brands]');
      this.locale = this.dataset.locale || 'et';
      this.intlLocale = this.locale === 'fi' ? 'fi-FI' : this.locale === 'en' ? 'en-IE' : 'et-EE';
      this.labels = RANGE_LABELS[this.locale] || RANGE_LABELS.en;
      this.hubUrl = this.dataset.hubUrl || window.location.pathname;
      this.hide = (this.dataset.hideModels || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
      this.brands = (this.dataset.brands || 'ridley:Ridley').split(',').map(function (pair) {
        var p = pair.split(':');
        return { key: p[0].trim().toLowerCase(), label: (p[1] || p[0]).trim() };
      }).filter(function (b) { return b.key; });
      this.activeBrand = this.brands[0] ? this.brands[0].key : 'ridley';
      this.activeRange = '';
      this.models = {};

      if (this.heroBrands) {
        this.heroBrands.innerHTML = '';
        var self0 = this;
        this.brands.forEach(function (b) { self0.heroBrands.appendChild(el('span', '', b.label)); });
      }

      var stage = this.querySelector('[data-bf-hub-stage]');
      if (stage && stage.querySelector('[data-bf-hub-bike]')) {
        var palette = (this.dataset.heroPalette || '').split(',').map(function (s) { return s.trim(); }).filter(hexToRgb);
        if (palette.length && window.BfHeroStage) this.hero = new window.BfHeroStage(stage, palette, this.querySelector('[data-bf-hub-caption]'));
      }

      var codeForm = this.querySelector('[data-bf-hub-code-form]');
      if (codeForm) {
        var self = this;
        codeForm.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var input = codeForm.querySelector('input[name="code"]');
          var code = (input.value || '').trim().toUpperCase();
          if (!code) return;
          var first = (self.models[self.activeBrand] || [])[0];
          var model = first ? first.modelcode : '';
          window.location.href = self.hubUrl + '?model=' + encodeURIComponent(model) + '&code=' + encodeURIComponent(code) + '#konfiguraator';
        });
      }

      this.loadAll();
    }

    loadAll() {
      var self = this;
      var jobs = this.brands.map(function (b) {
        return fetch(API + encodeURIComponent(b.key), { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (json) {
            var list = (json && json.result) || [];
            self.models[b.key] = list.filter(function (m) {
              return m && m.modelcode && !(m.attributes && m.attributes.archived) && self.hide.indexOf(m.modelcode.toUpperCase()) === -1;
            }).sort(function (a, c) {
              var ra = RANGE_ORDER.indexOf(a.attributes.range), rc = RANGE_ORDER.indexOf(c.attributes.range);
              if (ra !== rc) return (ra === -1 ? 99 : ra) - (rc === -1 ? 99 : rc);
              var ea = a.attributes.electric === 'Yes' ? 1 : 0, ec = c.attributes.electric === 'Yes' ? 1 : 0;
              if (ea !== ec) return ea - ec;
              return (a.attributes.position || 0) - (c.attributes.position || 0);
            }).map(function (m) { m.$brand = b.key; m.$brandLabel = b.label; return m; });
          })
          .catch(function () { self.models[b.key] = null; });
      });
      Promise.all(jobs).then(function () {
        var urlBrand = (new URLSearchParams(window.location.search).get('brand') || '').toLowerCase();
        if (urlBrand && self.models[urlBrand]) self.activeBrand = urlBrand;
        self.renderBrandTabs();
        self.render();
        self.setupHero();
      });
    }

    setupHero() {
      if (!this.hero) return;
      var wanted = (this.dataset.heroModel || '').toUpperCase();
      var all = [];
      var self = this;
      this.brands.forEach(function (b) { (self.models[b.key] || []).forEach(function (m) { all.push(m); }); });
      var pick = null;
      if (wanted) pick = all.filter(function (m) { return m.modelcode.toUpperCase() === wanted; })[0] || null;
      if (!pick) {
        // Most saturated frame colour recolours best.
        var best = -1;
        all.forEach(function (m) {
          var rgb = hexToRgb(m.attributes.extractedFrameColorFromImage || '');
          if (!rgb) return;
          var s = rgbToHsl(rgb[0], rgb[1], rgb[2])[1];
          if (s > best) { best = s; pick = m; }
        });
      }
      if (!pick) return;
      var img = pick.attributes.images && pick.attributes.images.image;
      var src = img && (img.highres || img.midres || img.uhd);
      if (!src) return;
      var label = (pick.$brandLabel || '') + ' ' + (pick.attributes.model || pick.modelcode);
      var hero = this.hero, refColor = pick.attributes.extractedFrameColorFromImage;
      loadLayerManifest(this.dataset.layersUrl).then(function (manifest) {
        if (manifest && manifest.cards && manifest.cards.length) return hero.setCards(manifest.cards);
        var entry = manifest && manifest[pick.modelcode.toUpperCase()];
        if (entry) return hero.setLayered(entry, label);
        return false;
      }).then(function (ok) {
        if (!ok) hero.setBike(src, refColor, label);
      });
    }

    renderBrandTabs() {
      if (!this.brandTabs) return;
      var self = this;
      var available = this.brands.filter(function (b) { return (self.models[b.key] || []).length; });
      this.brandTabs.innerHTML = '';
      if (available.length < 2) { this.brandTabs.hidden = true; return; }
      this.brandTabs.hidden = false;
      available.forEach(function (b) {
        var btn = el('button', 'bf-hub__brand-tab', b.label);
        btn.type = 'button';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', b.key === self.activeBrand ? 'true' : 'false');
        btn.addEventListener('click', function () {
          self.activeBrand = b.key;
          self.activeRange = '';
          self.brandTabs.querySelectorAll('.bf-hub__brand-tab').forEach(function (t) { t.setAttribute('aria-selected', t === btn ? 'true' : 'false'); });
          self.render();
        });
        self.brandTabs.appendChild(btn);
      });
    }

    render() {
      var self = this;
      if (!this.grid) return;
      this.grid.innerHTML = '';
      var list = this.models[this.activeBrand];
      if (list === null) {
        this.grid.appendChild(el('div', 'bf-hub__error', this.dataset.errorLabel || 'Mudelite laadimine ebaõnnestus. Proovi hiljem uuesti.'));
        if (this.tabs) this.tabs.hidden = true;
        return;
      }
      list = list || [];

      var ranges = [];
      list.forEach(function (m) {
        var r = m.attributes.range || '';
        if (r && ranges.indexOf(r) === -1) ranges.push(r);
      });

      if (this.tabs) {
        this.tabs.innerHTML = '';
        if (ranges.length > 1) {
          this.tabs.hidden = false;
          this.tabs.appendChild(this.makeTab(this.labels.all, '', this.activeRange === ''));
          ranges.forEach(function (r) { self.tabs.appendChild(self.makeTab(self.labels[r] || r, r, self.activeRange === r)); });
        } else {
          this.tabs.hidden = true;
        }
      }

      list.forEach(function (m) {
        var card = self.card(m);
        card.hidden = self.activeRange !== '' && (m.attributes.range || '') !== self.activeRange;
        self.grid.appendChild(card);
      });

      if (window.location.hash === '#konfiguraator') {
        var target = document.querySelector('bf-configurator:not([hidden])');
        if (target) requestAnimationFrame(function () { target.scrollIntoView({ behavior: 'auto', block: 'start' }); });
      }
    }

    makeTab(label, range, selected) {
      var self = this;
      var b = el('button', 'bf-hub__tab', label);
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', selected ? 'true' : 'false');
      b.addEventListener('click', function () {
        self.activeRange = range;
        self.tabs.querySelectorAll('.bf-hub__tab').forEach(function (t) { t.setAttribute('aria-selected', t === b ? 'true' : 'false'); });
        self.grid.querySelectorAll('.bf-hub__card').forEach(function (c) {
          c.hidden = range !== '' && c.dataset.range !== range;
        });
      });
      return b;
    }

    card(m) {
      var a = m.attributes || {};
      var name = a.model || m.modelcode;
      var href = this.hubUrl + '?model=' + encodeURIComponent(m.modelcode) + '&brand=' + encodeURIComponent(m.$brand || '') +
        '&name=' + encodeURIComponent((m.$brandLabel ? m.$brandLabel + ' ' : '') + name) + '#konfiguraator';
      var card = el('a', 'bf-hub__card');
      card.href = href;
      card.dataset.range = a.range || '';
      card.dataset.code = m.modelcode;

      var media = el('div', 'bf-hub__card-media');
      var img = document.createElement('img');
      var src = a.images && a.images.image;
      img.src = src ? (src.midres || src.highres || src.thumb || '') : '';
      img.alt = name;
      img.loading = 'lazy';
      img.width = 1024;
      img.height = 640;
      media.appendChild(img);
      if (a.niveau) media.appendChild(el('span', 'bf-hub__badge', a.niveau));
      if (a.electric === 'Yes') media.appendChild(el('span', 'bf-hub__badge bf-hub__badge--electric', this.dataset.electricLabel || 'E-bike'));
      card.appendChild(media);

      var body = el('div', 'bf-hub__card-body');
      body.appendChild(el('span', 'bf-hub__card-range', (m.$brandLabel ? m.$brandLabel + ' · ' : '') + (this.labels[a.range] || a.range || '')));
      body.appendChild(el('h3', 'bf-hub__card-name', name));
      var from = parseFloat(m.priceFrom);
      if (!isNaN(from) && from > 0) {
        var price = el('span', 'bf-hub__card-price');
        price.appendChild(document.createTextNode((this.dataset.fromLabel || 'alates') + ' '));
        price.appendChild(el('strong', '', money(from, m.priceFromCurrency, this.intlLocale)));
        body.appendChild(price);
      }
      var cta = el('span', 'bf-hub__card-cta', this.dataset.startLabel || 'Alusta konfigureerimist');
      cta.insertAdjacentHTML('beforeend', ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>');
      body.appendChild(cta);
      card.appendChild(body);
      return card;
    }
  }

  if (!customElements.get('bf-configurator-hub')) {
    customElements.define('bf-configurator-hub', BfConfiguratorHub);
  }
})();
